import styled, { css } from 'styled-components';
import {
  ChatBubble as CommentIcon,
  AccessTimeRounded,
  ErrorOutlineRounded,
} from '@mui/icons-material';

import { ReactComponent as PinIcon } from '../../../../../../../assets/icons/v2/pin-filled.svg';
import { Card } from '../../../../../../../components/v2/Card';
import colors from '../../../../../../../styles/colors';

const postIconStyle = css`
  color: ${colors.shades.secondary3};
  font-size: 20px;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const StyledPinIcon = styled(PinIcon)`
  width: 13px;
  height: 13px;
  color: ${colors.shades.secondary8};
`;

const PinnedLabel = styled.span`
  font-size: 13px;
  font-weight: 400;
`;

const StyledCard = styled(Card)`
  display: flex;
  margin: 10px 0;
  padding: 20px;
  border-radius: 8px;
  background: ${colors.base.alpha};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  row-gap: 10px;
  width: 100%;

  ${({ $isFullPostView }) => $isFullPostView && css`
    overflow: hidden;
    padding: 10px 20px;
    row-gap: 5px;
  `}

  ${({ $isPinned }) => $isPinned && css`
    border: 1px solid ${colors.shades.primary1};
    border-left: 4px solid ${colors.shades.primary1};
  `}
`;

const Message = styled.div`
  width: 100%;
  font-size: 15px;
  white-space: pre-wrap;
`;

const TagContainer = styled.div`
  width: fit-content;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 5px;
`;

const PartialCountsHint = styled.span`
  color: ${colors.shades.gamma10};
  font-size: 12px;
  font-style: italic;
`;

const BottomRow = styled.div`
  display: flex;
  justify-content: ${({ $isScheduled }) => ($isScheduled ? 'flex-end' : 'space-between')};
  align-items: center;
`;

const LikesContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  color: ${colors.shades.beta1};
  font-size: 15px;
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  color: ${colors.shades.beta1};
  font-size: 15px;
  background-color: ${colors.shades.gamma5};
  border-radius: 20px;
  padding: 5px 10px;
  cursor: ${({ $isFullPostView }) => ($isFullPostView ? 'default' : 'pointer')};

  ${({ $isFullPostView }) => !$isFullPostView && css`
    transition: background-color 0.2s;
    &:hover {
      background-color: ${colors.shades.gamma8};
    }
  `}
`;

const StyledCommentIcon = styled(CommentIcon)`
  ${postIconStyle};
`;

const BannerIconStyle = css`
  font-size: 16px;
`;

const StyledScheduledIcon = styled(AccessTimeRounded)`
  ${BannerIconStyle};
`;

const StyledFailedIcon = styled(ErrorOutlineRounded)`
  ${BannerIconStyle};
`;

const PostIconContainer = styled.div`
  display: flex;
  gap: 10px;
`;

const ProfileCardWrapper = styled.div`
  width: 30%;
`;

const Banner = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  background-color: ${({ $isError }) => ($isError ? colors.shades.danger2 : colors.shades.warning1)};
  border: 1px solid ${({ $isError }) => ($isError ? colors.shades.danger4 : colors.shades.warning2)};
  color: ${({ $isError }) => ($isError ? colors.base.danger : colors.base.warning)};
`;

export {
  StyledCard as Card,
  ProfileCardWrapper,
  Message,
  TagContainer,
  BottomRow,
  IconContainer,
  StyledCommentIcon as CommentIcon,
  StyledScheduledIcon as ScheduledIcon,
  StyledFailedIcon as FailedIcon,
  PostIconContainer,
  LikesContainer,
  PinnedLabel,
  HeaderContainer,
  StyledPinIcon,
  Banner,
  PartialCountsHint,
};
